<script lang="ts">
    import { openModal } from 'svelte-modals';
    import * as Sentry from '@sentry/browser';
    import { _ } from 'svelte-i18n';

    import IconPlanningStep4 from '../../../shared/Icons/IconPlanningStep4.svelte';
    import { deliveryList, planning, scenarioManager } from '../../../../stores/store';
    import IconPlanningStep3 from '../../../shared/Icons/IconPlanningStep3.svelte';
    import { AssignmentBulkActions } from '../AssignmentBulkActions';
    import ModalError from '../../../shared/Modals/ModalError.svelte';
    import IconClose from '../../../shared/Icons/IconClose.svelte';
    import IconRoute from '../../../shared/Icons/IconRoute.svelte';
    import { api } from '../../../../stores/api';
    import Spinner from '../../../shared/Spinner/Spinner.svelte';
    import { features } from '../../../shared/Features/features';
    import { type TargetStageTypes } from '../TargetStage';
    import { ScenarioApi } from '../ScenarioApi';
    import Dummy from '../../../shared/Dummy.svelte';
    import Disabled from '../../../shared/Disabled.svelte';
    import { BulkAction } from '../BulkAction';
    import BulkActionOne from '../BulkActionOne.svelte';

    export let showMonit = false;
    export let readonlyMode: boolean = false;

    let countAvailableAssignmentsToAccept = 0;
    let countAvailableAssignmentsToLock = 0;
    let countAvailableAssignmentsToCalc = 0;

    let availableAssignmentsToAccept: number[] = [];
    let availableAssignmentsToLock: number[] = [];
    let availableAssignmentsToCalc: number[] = [];

    let acceptContainerComponent = Dummy;
    let calcContainerComponent = Dummy;
    let lockContainerComponent = Dummy;

    let selectedAssignments: number[] = [];

    let inProgress: boolean = false;

    let actions: Record<string, BulkAction> = {
        'assign': new BulkAction(
            IconPlanningStep3,
            $_('approve'),
            (items: number[]) => {
                makeBulkActions(items, 'assign');
            },
            true
        ),
        'calculate': new BulkAction(
            IconRoute,
            $_('Oblicz trasy'),
            (items: number[]) => {
                makeBulkActions(items, 'calculate');
            },
            true
        ),
        'send': new BulkAction(
            IconPlanningStep4,
            $_('submit_for_realization'),
            (items: number[]) => {
                makeBulkActions(items, 'send');
            },
            true
        )
    }

    function getAssignmentsForAction(action: string): number[] {
        switch (action) {
            case 'assign':
                return $scenarioManager.getAssignmentsIdsEnabledToAccept();
            case 'calculate':
                return $scenarioManager.getIdsRoutesToCalculateWithAccept();
            case 'send':
                return $scenarioManager.getRoutesToLockIdsWithAccept();
        }
        return [];
    }

    function filterSelected(items: number[]): number[] {
        return selectedAssignments.filter(assId =>
            items.includes(assId)
        );
    }

    function makeBulkActions(assignments: number[], targetStage: TargetStageTypes) {
        if (readonlyMode) {
            console.warn('readonlyMode, cannot accept action');
            return;
        }

        if ($planning.currentScenarioId === null) {
            console.warn('makeBulkActions, Scenario is not selected');
            return;
        }

        inProgress = true;

        // console.log(
        //     'makeBulkActions, setAsLocked',
        //     $planning.selectedAssignments,
        //     $planning.selectedDay
        // );

        $planning.selectedAssignments = [];

        console.log('makeBulkActions', targetStage, assignments);

        assignments.forEach(assId => {
            console.log('makeBulkActions, setTargetStage, setAssignmentBusyStatus', assId);
            $scenarioManager.setAssignmentTargetStage(assId, targetStage);
            $scenarioManager.setAssignmentBusyStatus(assId, true);
            // console.log(
            //     'makeBulkActions, setBusy',
            //     $scenarioManager.getScenarioSections(false, false, false).map(s => {
            //         return { id: s.getId(), busy: s.isBusy() };
            //     })
            // );
        });
        $scenarioManager = $scenarioManager;
        ScenarioApi.setTargetStage($api, targetStage, assignments)
            .then(res => {
                console.log('makeBulkActions, setTargetStage, res', res);
            })
            .catch(err => {
                console.error('makeBulkActions, setTargetStage, err', err);
            })
            .finally(() => {
                inProgress = false;
            });

    }

    $: {

        selectedAssignments = $planning.selectedAssignments;

        for (let a in actions) {
            actions[a] = actions[a].setItems(filterSelected(getAssignmentsForAction(a)));
        }

    }
</script>

<div class="lm--action_bar" style="display: flex;">
    {#if inProgress}
        <Spinner />
    {:else}
        <div>
            <span class="text-span-10">{$_('Selected items')}</span>:
            <strong>{$planning.selectedAssignments.length}</strong>
        </div>
        <div class="lm--action_bar_loptions" class:readonlyMode>
            {#each Object.values(actions) as action}
                <BulkActionOne {action}/>
            {/each}
        </div>
        <IconClose
            scale={0.7}
            on:click={() => {
                console.log('close');
                $planning.selectedAssignments = [];
                showMonit = false;
            }}
        />
    {/if}
</div>

<style>
    .lm--action_bar {
        font-size: 14px;
        z-index: 1000;
        min-height: 72px;
        color: #fff;
        background-color: #397be5;
        justify-content: space-between;
        align-items: center;
        padding: 10px 30px;
        display: none;
        position: absolute;
        column-gap: 20px;
        top: 0;
        bottom: auto;
        left: 0;
        right: 0;
    }
    .lm--action_bar_loptions {
        grid-column-gap: 30px;
        grid-row-gap: 20px;
        /*filter: invert();*/
        color: #000;
        align-items: center;
        font-weight: 500;
        line-height: 14px;
        display: flex;
        flex-wrap: wrap;
    }
    .readonlyMode {
        pointer-events: none;
        opacity: 0.5;
    }
</style>
